/**
 * @fileoverview Renders import missions button
 */

import React from 'react'
import injectStyles from 'react-jss'
import { Button } from '../../../../../Components/Buttons/Button'

const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    '& + *': {
      marginLeft: '16px',
    },
    '& button': {
      lineHeight: 'inherit',
      height: '40px',
    },
  },
}

const GenerateButton = ({ onClick, hidden, classes }) => {
  if (hidden) return null
  return (
    <div className={classes.wrapper}>
      <Button onClick={onClick} cypress_id="roster-generate-missions-button">
        {'✨ Generate Missions'}
      </Button>
    </div>
  )
}

export default injectStyles(styles)(GenerateButton)
